'use client';

import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Topbar from './Topbar';

interface AppLayoutProps {
  children: React.ReactNode;
  title?: string;
  subtitle?: string;
}

export default function AppLayout({ children, title, subtitle }: AppLayoutProps) {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="min-h-screen bg-background">
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed(!collapsed)} />
      <Topbar
        sidebarCollapsed={collapsed}
        onMobileMenuToggle={() => setCollapsed(!collapsed)}
        title={title}
        subtitle={subtitle}
      />
      <main
        className="content-transition pt-16 min-h-screen"
        style={{ marginLeft: collapsed ? '64px' : '240px' }}
      >
        <div className="max-w-screen-2xl mx-auto px-4 lg:px-6 xl:px-8 2xl:px-10 py-6">
          {children}
        </div>
      </main>
    </div>
  );
}